"use client";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { TinaMarkdown } from "tinacms/dist/rich-text";
// import { Video } from "@/components";

function Video({ url, title }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!url || !isMounted) return null;

  return (
    <>
      <div className="rounded-lg overflow-hidden h-[240px] md:h-[404px]">
        <ReactPlayer
          url={url}
          className="w-full [&>iframe]:w-full "
          width="100%"
          height="100%"
          controls
        />
      </div>
    </>
  );
}

export default function Markdown({ content }) {
  return (
    <div className="markdown">
      <TinaMarkdown
        content={content}
        components={{
          Video,
          table: (props) => (
            <div className="table-wrapper">
              <table {...props} />
            </div>
          ),
        }}
      />
    </div>
  );
}

// import { Image } from "@/components";
// import { Play } from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "@/ui/dialog";
